import type { LucideIcon } from 'lucide-react';

import { cn } from '@/utils/cn';

export type SummaryTileTone = 'blue' | 'green' | 'violet' | 'amber' | 'rose' | 'slate';

export type SummaryTileItem = {
  id: string;
  label: string;
  value: string;
  icon: LucideIcon;
  tone: SummaryTileTone;
};

type SummaryTilesProps = {
  items: SummaryTileItem[];
  className?: string;
  cardClassName?: string;
  compact?: boolean;
};

export function SummaryTiles({ items, className, cardClassName, compact = false }: SummaryTilesProps) {
  return (
    <section className={cn('dashboard-summary-grid', className)}>
      {items.map((item) => {
        const Icon = item.icon;

        return (
          <article
            key={item.id}
            className={cn('surface-card summary-card', compact && 'summary-card--compact', cardClassName)}
          >
            <div className="summary-card__head">
              <div>
                <p className="metric-label">{item.label}</p>
                <h2 className="metric-value">{item.value}</h2>
              </div>
              <span className={cn('summary-card__icon', `summary-card__icon--${item.tone}`)}>
                <Icon size={20} strokeWidth={2} />
              </span>
            </div>
          </article>
        );
      })}
    </section>
  );
}